import OrganisationModel from '../model/OrganisationModel'
import TextControl from '../../../lib/ui/TextControl'
import PickerControl from '../../../lib/ui/PickerControl'
import ImageSelectControl from '../../../lib/ui/ImageSelectControl'
import SelectLocation from '../../location/action/SelectLocation'

export default class OrganisationForm {
  constructor (element, args) {
    let fieldsetOrganisation = document.createElement('fieldset')
    let legendOrganisation = document.createElement('legend')
    legendOrganisation.innerHTML = 'Organisatie'
    fieldsetOrganisation.appendChild(legendOrganisation)
    let popup = null
    this.id = args.organisation.values.id
    this.image = new ImageSelectControl(fieldsetOrganisation, {label: 'Afbeelding', value: args.organisation.values.image, readonly: window.PRIM.hasReadonlyModuleAccess('organisations'), onchange: args.onchange})
    this.name = new TextControl(fieldsetOrganisation, {label: 'Naam', value: args.organisation.values.name, readonly: window.PRIM.hasReadonlyModuleAccess('organisations'), onchange: args.onchange})
    this.location = new PickerControl(fieldsetOrganisation, {label: 'Hoofdvestiging', value: args.organisation.values.location_id,
      onchange: args.onchange,
      onselect: (item) => {
        if (item.values.id) {
          window.PRIM.navigate('/locations/' + item.values.id)
        }
      },
      onclick: () => {
        let popupElement = document.getElementById('popup')
        let viewportElement = document.getElementById('viewport')

        popup = new SelectLocation(popupElement, {
          onok: (item) => {
            if (item && item.values.id) {
              this.location.setValue(item.values.id, item)
            } else {
              this.location.setValue(null, null)
            }

            viewportElement.classList.remove('invisible')
            popupElement.classList.add('invisible')
            popupElement.innerHTML = ''
            this.location.onchange()
          },
          oncancel: () => {
            viewportElement.classList.remove('invisible')
            popupElement.classList.add('invisible')
            popupElement.innerHTML = ''
          }
        })
        viewportElement.classList.add('invisible')
        popupElement.classList.remove('invisible')
      }
    })
    this.vat = new TextControl(fieldsetOrganisation, {label: 'BTW nummer', value: args.organisation.values.vat, readonly: window.PRIM.hasReadonlyModuleAccess('organisations'), onchange: args.onchange})
    this.coc = new TextControl(fieldsetOrganisation, {label: 'KVK nummer', value: args.organisation.values.coc, readonly: window.PRIM.hasReadonlyModuleAccess('organisations'), onchange: args.onchange})

    let fragment = document.createDocumentFragment()
    fragment.appendChild(fieldsetOrganisation)

    element.appendChild(fragment)
  }

  getValue () {
    let organisation = new OrganisationModel()
    organisation.values.image = this.image.getValue()
    organisation.location = this.location.getItem()
    organisation.values.id = this.id
    organisation.values.name = this.name.getValue()
    organisation.values.location_id = this.location.getValue()
    organisation.values.vat = this.vat.getValue()
    organisation.values.coc = this.coc.getValue()
    return organisation
  }

  setValue (organisation) {
    this.id = organisation.values.id
    this.image.setValue(organisation.values.image)
    this.name.setValue(organisation.values.name)
    this.location.setValue(organisation.values.location_id, organisation.location)
    this.vat.setValue(organisation.values.vat)
    this.coc.setValue(organisation.values.coc)
  }
}



// WEBPACK FOOTER //
// ./js/modules/organisation/ui/OrganisationForm.js